// src/components/togglebuttons/MapPanel.js
import React, { useCallback, useRef } from "react"
import { useMap } from "react-leaflet"

import { Paper, IconButton, Typography, Box, Divider } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import MapPanelToggles from "./MapPanelToggles"
import { togglePanel } from "@/reducers/panelsReducer"
import { onMouseEnter, onMouseLeave } from "@/utils/mapUx"
import VisibilitySwitch from "@/components/ui/VisibilitySwitch";
import { LEFT_PANEL_WIDTH } from "@/config/layout";
import { useLayoutBounds } from "@/features/layout/layoutBounds.jsx";
import {
  PANEL_TITLE_SX,
  PANEL_SUBTITLE_SX,
  PANEL_CARD_SX,
  CARD_TITLE_SX,
  PANEL_HEADER_DIVIDER_SX,
} from "@/theme/panelStyles";

export default function MapPanel({
  openPanels,
  dispatch,
  setVoyageActive,
  switchMapSettingsActive,
  setSwitchMapSettingsActive,
  toogleButtonsOnOff,
  setToogleButtonsOnOff,
}) {
  const map = useMap()
  const panelRef = useRef(null)

  const isOpen = openPanels.map
  const bounds = useLayoutBounds()
  const panelMaxHeight = bounds.panelHeight

  const handleClose = useCallback(() => {
    dispatch(togglePanel("map"))
    onMouseLeave(map)
  }, [dispatch, map])

  if (!isOpen) return null

  return (
    <Paper
      key="map-settings-panel"
      data-tour="map-panel"
      ref={panelRef}
      elevation={0}
      sx={{
        position: "absolute",
        top: bounds.top,
        zIndex: 1000,
        bgcolor: "background.paper",
        width: `${LEFT_PANEL_WIDTH}px`,
        color: "#004f7d",
        borderRadius: "0px",
        marginLeft: `${bounds.left}px`,
        overflowY: "auto",
        maxHeight: `${panelMaxHeight}px`,
        boxSizing: "border-box",
        p: 1.5,
      }}
      onMouseEnter={() => {
        setVoyageActive(false)
        onMouseEnter(map)
      }}
      onMouseLeave={() => {
        setVoyageActive(true)
        onMouseLeave(map)
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1.5 }}>
        <Box>
          <Typography sx={PANEL_TITLE_SX}>Map Settings</Typography>
          <Typography sx={PANEL_SUBTITLE_SX}>Map overlay controls</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <VisibilitySwitch
            checked={switchMapSettingsActive}
            onChange={(e) => setSwitchMapSettingsActive(e.target.checked)}
            slotProps={{ input: { "aria-label": "toggle map settings visibility" } }}
          />
          <IconButton aria-label="close" onClick={handleClose} sx={{ color: "#004f7d" }}>
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>

      <Divider sx={PANEL_HEADER_DIVIDER_SX} />

      <Box sx={PANEL_CARD_SX}>
        <Typography sx={{ ...CARD_TITLE_SX, mb: 1 }}>
          Available Layers
        </Typography>
        <Divider sx={{ mb: 1 }} />
        <MapPanelToggles toogleButtonsOnOff={toogleButtonsOnOff} setToogleButtonsOnOff={setToogleButtonsOnOff} />
      </Box>
    </Paper>
  )
}
